import s from "./styles.scss";
import { Input, Label } from "reactstrap";
import React from "react";
import { useSectionField } from "../../../../../hooks/useSectionField";
import withStyles from "isomorphic-style-loader/withStyles";

interface SectionEditorProps {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeOrigin: string;
  selectedSection: string | null;
}

const SectionEditor: React.FC<SectionEditorProps> = ({
  iframeRef,
  iframeOrigin,
  selectedSection,
}) => {
  const { value: fontSize, onChange: onFontSizeChange } = useSectionField(
    iframeRef,
    iframeOrigin,
    selectedSection,
    "news-feed",
    ".main-title",
    "style",
    "fontSize"
  );

  const {
    value: mainTitleText,
    onChange: onMainTitleTextChange,
  } = useSectionField(
    iframeRef,
    iframeOrigin,
    selectedSection,
    "news-feed",
    ".main-title",
    "text"
  );

  const {
    value: mainTitleBackgroundColor,
    onChange: onMainTitleBackgroundColorChange,
  } = useSectionField(
    iframeRef,
    iframeOrigin,
    selectedSection,
    "news-feed",
    ".main-title",
    "style",
    "background-color"
  );

  const {
    value: mainTitleHtml,
    onChange: onMainTitleHtmlChange,
  } = useSectionField(
    iframeRef,
    iframeOrigin,
    selectedSection,
    "news-feed",
    ".news-feed",
    "html"
  );

  return (
    <>
      {selectedSection === "news-feed" ? (
        <>
          <div className={s.inputContainer}>
            <Label for="mainTitleFontSize" className={s.inputLabel}>
              Main Title font size:
            </Label>
            <Input
              type="number"
              id="mainTitleFontSize"
              value={parseInt(fontSize, 10) || ""}
              className={s.inputField}
              onChange={onFontSizeChange}
            />
          </div>

          <div className={s.inputContainer}>
            <Label for="buttonLabel" className={s.inputLabel}>
              Main title text
            </Label>
            <Input
              type="text"
              id="buttonLabel"
              value={mainTitleText}
              className={s.inputField}
              onChange={onMainTitleTextChange}
            />
          </div>

          <div className={s.inputContainer}>
            <Label for="mainTitleBackgroundColor" className={s.inputLabel}>
              Main title background color
            </Label>
            <Input
              type="color"
              id="mainTitleBackgroundColor"
              value={mainTitleBackgroundColor || "#ffffff"}
              onChange={onMainTitleBackgroundColorChange}
            />
          </div>

          <div className={s.inputContainer}>
            <Label for="mainTitleHtml" className={s.inputLabel}>
              Main title HTML
            </Label>
            <Input
              type="textarea"
              id="mainTitleHtml"
              value={mainTitleHtml}
              className={s.inputField}
              onChange={onMainTitleHtmlChange}
              rows={4}
            />
          </div>
        </>
      ) : (
        <p>Click a section to start editing…</p>
      )}
    </>
  );
};

export default withStyles(s)(SectionEditor);
